import { render, staticRenderFns } from "./ALiquidacioncartera.vue?vue&type=template&id=70eaa4c0"
import script from "./ALiquidacioncartera.vue?vue&type=script&lang=js"
export * from "./ALiquidacioncartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports